// Custom backend authentication service
// Replaces Supabase auth functionality with custom backend implementation

import { apiFetch } from '../api/apiClient';

export const API_BASE = 'https://api-airolounge.airolabs.ai/api';
// export const API_BASE = 'http://localhost:3000/api';

export const authService = {
  // Replace supabase.auth.signInWithOAuth() with Google
  async loginWithGoogle() {
    try {
      window.location.href = `${API_BASE}/auth/google`;
    } catch (error) {
      console.error('Google login redirect failed:', error);
      throw new Error('Failed to initiate Google login');
    }
  },

  // Replace supabase.auth.signInWithOAuth() with Microsoft/Azure
  async loginWithMicrosoft() {
    try {
      window.location.href = `${API_BASE}/auth/azure`;
    } catch (error) {
      console.error('Microsoft login redirect failed:', error);
      throw new Error('Failed to initiate Microsoft login');
    }
  },

  // Replace supabase.auth.getSession()
  async getSession() {
    try {
      const response = await apiFetch('/auth/status');
      return await response.json();
    } catch (error) {
      console.error('Failed to get session:', error);
      throw new Error('Failed to retrieve session');
    }
  },

  // Replace supabase.auth.getUser()
  async getUser() {
    try {
      const response = await apiFetch('/auth/profile');
      return await response.json();
    } catch (error) {
      console.error('Failed to get user:', error);
      throw new Error('Failed to retrieve user profile');
    }
  },

  // Get current employee details
  async getCurrentEmployee() {
    try {
      const response = await apiFetch('/employees/me');
      return await response.json();
    } catch (error) {
      console.error('Failed to get current employee:', error);
      throw new Error('Failed to retrieve employee details');
    }
  },
  // Replace supabase.auth.signOut()
  async signOut() {
    try {
      const response = await apiFetch('/auth/logout', {
        method: 'POST',
      });
      
      // Clear local storage
      localStorage.removeItem('userToken');
      localStorage.removeItem('user');
      
      return await response.json();
    } catch (error) {
      console.error('Failed to sign out:', error);
      throw new Error('Failed to sign out');
    }
  },

  // Helper method to check if user is authenticated
  async isAuthenticated() {
    try {
      const session = await this.getSession();
      return session && session.isAuthenticated === true;
    } catch (error) {
      return false;
    }
  }
};